import { render } from "./TopbarNotificationBell.vue?vue&type=template&id=2f634b83&scoped=true"
import script from "./TopbarNotificationBell.vue?vue&type=script&lang=js"
export * from "./TopbarNotificationBell.vue?vue&type=script&lang=js"

import "./topbar-notification-bell.scss?vue&type=style&index=0&id=2f634b83&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f634b83"]])

export default __exports__